import React from 'react';

const ModalTabs = ({ activeTab, onTabClick }) => {
    const tabs = [
        { id: 'category_v', label: 'Categories' },
        { id: 'department_v', label: 'Departments' },
        { id: 'district_v', label: 'Districts' },
        { id: 'upazila_v', label: 'Upazila' },
        { id: 'source_v', label: 'Sources' },
    ];

    return (
        <div className="flex flex-wrap justify-center gap-3 mb-2 mt-9 md:mt-0 lg:mt-0">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`px-4 py-2 rounded-md text-sm font-medium shrink-0 ${activeTab === tab.id
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                    onClick={() => onTabClick(tab.id)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default ModalTabs;